module.exports = __webpack_public_path__ + "static/media/dummyPDF.213eacd2.pdf";